module.exports = __webpack_public_path__ + "static/media/firstbg.22b31c1c.png";